/**Dependencies */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import _ from "lodash";
/**Components */
import { CardResultHotel } from "../components/CardResultHotel";
import { CarouselCards } from "../components/CarouselCards";
import { SectionAdvise } from "../components/SectionAdvise";
import { SearchEngine } from "../components/SearchEngine";
import { CheckOutCart } from "../components/CheckOutCart";

// Services
import {
  getCollectionByName,
  getCollections,
  getHotelsByCollectionAndSeason,
  getSeasons,
} from "../services/CollectionsService";

// Helpers
import { fetchMarkup } from "../helpers";

/**Styles */
import "../styles/colecciones.scss";

/**Images */
import BannerNecesitasAyuda from "../images2/Banner-contacto-renta-autos.png";
import BannerNecesitasAyudaMovil from "../images2/Banner-contacto-renta-autos-movil.png";
import fondoVerano from "../images2/fondo_verano.png";
import fondoPrimavera from "../images2/fondo_primavera.png";
import fondoOtoño from "../images2/fondo_otoño.png";
import fondoInvierno from "../images2/fondo_invierno.png";
import iconInvierno from "../images2/icons/icon-Invierno.png";
import iconOtoño from "../images2/icons/icon-Otoño.png";
import iconPrimavera from "../images2/icons/icon-Primavera.png";
import iconVerano from "../images2/icons/icon-Verano.png";
import { Loader } from "../components/Loader";
import Skeleton from "react-loading-skeleton";
import { BannerDudas } from "../components/BannerDudas";

export const Colecciones = () => {
  const [selectedSeason, setSelectedSeason] = useState("Verano");
  const [loading, setLoading] = useState(false);
  const [visibleCards, setVisibleCards] = useState(5);
  const [showSearchEngine, setShowSearchEngine] = useState(false);
  const [seasons, setSeasons] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [hotelsByCAndS, setHotelsByCAndS] = useState([]);
  const [markup, setMarkup] = useState("");
  const [collection, setCollection] = useState([]);
  const [collections, setCollections] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const queryParams = parseQueryParams(location.search);
  const category = queryParams.category;
  const idCategory = queryParams.idCategory;
  let req = {};
  let categoria = "";

  const handleShowMore = () => {
    setVisibleCards((prev) => prev + 5);
  };

  const currentSeason = seasons?.find(
    (season) => _.capitalize(season?.name_season) === selectedSeason
  );

  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        const response = await seasonsResponse();
        setSeasons(response);
      } catch (error) {
        console.error("Error fetching seasons:", error);
      }
    };
    fetchSeasons();
  }, []);

  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("HOTELERIA");
        setMarkup(markupData.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);

  const seasonsResponse = async () => {
    try {
      const response = await getSeasons();
      return response;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };

  if (idCategory == 1) {
    categoria = "first";
  } else if (idCategory == 2) {
    categoria = "second";
  } else if (idCategory == 3) {
    categoria = "third";
  } else if (idCategory == 4) {
    categoria = "four";
  } else if (idCategory == 5) {
    categoria = "five";
  } else if (idCategory == 6) {
    categoria = "six";
  }

  if (queryParams.in && queryParams.out) {
    const checkin = queryParams.in;
    const checkout = queryParams.out;

    req = {
      season: selectedSeason,
      collection: categoria,
      checkin: checkin,
      checkout: checkout,
    };
  } else {
    req = {
      season: selectedSeason,
      collection: categoria,
    };
  }
  useEffect(() => {
    // hotelsCollectionByCAndS(req);
    const fetchHotelsByCollectionAndSeason = async () => {
      setLoading(true);
      try {
        const response = await getHotelsByCollectionAndSeason(req);
        setLoading(false);
        setHotelsByCAndS(response);
      } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
      }
    };
    fetchHotelsByCollectionAndSeason();
  }, [idCategory, selectedSeason]);

  // const hotelsCollectionByCAndS = async (arrData) => {
  //   try {
  //     setLoading(true);
  //     const response = await getHotelsByCollectionAndSeason(arrData);
  //     setHotelsByCAndS(response);
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //     throw error;
  //   }
  //   setLoading(false);
  // };

  useEffect(() => {
    const obtenerCollection = async () => {
      // setLoading(true);
      try {
        const response = await getCollectionByName(queryParams.category);
        // setLoading(false);

        setCollection(response);
      } catch (error) {
        throw new Error("Error fetching Data. Collection: " + error);
      }
    };
    obtenerCollection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams?.category, idCategory]);

  useEffect(() => {
    const obtenerCollections = async () => {
      // setLoading(true);
      try {
        const response = await getCollections();
        // setLoading(false);

        setCollections(response);
      } catch (error) {
        throw new Error("Error fetching Data. Collections: " + error);
      }
    };
    obtenerCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (queryParams.in && queryParams.out) {
      const habitacionesFormatted = Object.keys(queryParams)
        .filter((key) => key.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
        .map((key, index) => {
          const [adultos, menores, edades] = queryParams[key].split("|");

          // Convertir edades (si las hay) en un array
          const edadesArray =
            edades === "0" || !edades ? [] : edades.split(",").map(Number);

          // Devolver el objeto con la estructura requerida
          return {
            room: index + 1, // El número de la habitación es el índice + 1
            adults: parseInt(adultos, 10),
            minors: parseInt(menores, 10),
            ages: edadesArray,
          };
        });
      setRooms(habitacionesFormatted);
    }
  }, [location.search]);
  const handleSelectHotel = (hotel) => {
    let checkin = "";
    let checkout = "";
    let adultos;
    let menores;
    let edades;
    let paxParams;
    const storedArray = rooms;
    if (queryParams.in && queryParams.out) {
      checkin = queryParams.in;
      checkout = queryParams.out;
    } else {
      checkin = hotel.checkin;
      checkout = hotel.checkout;
    }
    adultos = hotel.num_adults;
    menores = hotel.num_minors;
    edades = hotel.age_minors ? hotel.age_minors : "0";
    if (queryParams.in && queryParams.out) {
      paxParams = storedArray
        .map((hab, index) => {
          const adultos = hab?.adults;
          const menores = hab?.minors;
          const edades = hab?.ages?.length > 0 ? hab?.ages?.join(",") : "0";
          return `pax${index + 1}=${adultos}|${menores}|${edades}`;
        })
        .join("&");
    } else {
      paxParams = `pax1=${adultos}|${menores}|${edades}`;
    }

    let url = `/info-hotel?idHotel=${
      hotel.id
    }&in=${checkin}&out=${checkout}&hab=${
      storedArray?.length > 0 ? storedArray?.length : 1
    }&${paxParams}`;
    // Usar React Router para redirigir
    navigate(url);
  };
  return (
    <div>
      {loading && <Loader />}
      {/* Banner dinámico */}
      {collection?.image_collection && (
        <div className=" pt-0">
          <img
            src={`https://panel.marzahtravel.com/assets/uploads/colecciones/lista/${collection?.image_collection}`}
            alt="Logo"
            style={{ width: "100%", height: "100%", top: "20px", left: "20px" }}
          />
        </div>
      )}
      <div
        className="list-seasons mb-5"
        // style={
        //   currentSeason?.name_season === "otoño"
        //     ? {
        //         backgroundImage: `url(${fondoOtoño})`,
        //         backgroundSize: "10% 28%",
        //         backgroundRepeat: "repeat-x",
        //         backgroundPosition: "top left",
        //         padding: "35px 0",
        //         display: "flex",
        //       }
        //     : currentSeason?.name_season === "primavera"
        //     ? {
        //         backgroundImage: `url(${fondoPrimavera})`,
        //         backgroundSize: "auto",
        //         padding: "35px 0",
        //       }
        //     : currentSeason?.name_season === "verano"
        //     ? {
        //         backgroundImage: `url(${fondoVerano})`,
        //         backgroundSize: "auto",
        //         padding: "35px 0",
        //       }
        //     : currentSeason?.name_season === "invierno"
        //     ? {
        //         backgroundImage: `url(${fondoInvierno})`,
        //         backgroundSize: "auto",
        //         padding: "35px 0",
        //       }
        //     : { marginTop: "35px" }
        // }
      >
        <Container>
          {/* Filtros */}
          <div className="text-center mb-4">
            {seasons?.map((season) => (
              <Button
                key={season.id}
                variant={
                  selectedSeason === _.capitalize(season?.name_season)
                    ? "ligth active"
                    : "ligth"
                }
                className="mx-2"
                onClick={() =>
                  setSelectedSeason(_.capitalize(season?.name_season))
                }
              >
                <img
                  src={
                    season?.name_season === "verano"
                      ? iconVerano
                      : "" || season?.name_season === "primavera"
                      ? iconPrimavera
                      : "" || season?.name_season === "invierno"
                      ? iconInvierno
                      : "" || season?.name_season === "otoño"
                      ? iconOtoño
                      : ""
                  }
                  alt={season?.name_season}
                  style={{ width: "20px", height: "20px", marginRight: "10px" }}
                />
                {_?.capitalize(season?.name_season)}
              </Button>
            ))}
          </div>
          <div className="text-center mt-3 d-flex justify-content-center mb-5">
            <div className="d-flex justify-content-center">
              <Button
                className="btn-blue btn-toggle-search fw-bolder"
                onClick={() => setShowSearchEngine((prev) => !prev)}
                style={{
                  borderRadius: "15px",
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  width: "100%",
                }}
              >
                {showSearchEngine ? "Cerrar buscador" : "¿Que días viajas?"}
              </Button>
            </div>
          </div>
          {showSearchEngine && (
            <div className="col-lg-12 mt-1 d-flex justify-content-center">
              <div className="col-lg-8">
                <SearchEngine
                  isModify={true}
                  isInfoHotel={true}
                  isCollection={true}
                  totalRooms={[]}
                  isModifyHotel={true}
                  totalPersons={[]}
                  category={category}
                  idCategory={idCategory}
                />
              </div>
            </div>
          )}
          {/* Cards */}
          <Row>
            {!loading ? (
              <>
                {hotelsByCAndS.length > 0 ? (
                  <>
                    {hotelsByCAndS.slice(0, visibleCards).map((hotel) => (
                      <Col key={hotel.id} sm={12} md={6} className="mb-4">
                        <CardResultHotel
                          percentageMarkup={markup}
                          hotel={hotel}
                          isExperiencies={false}
                          isCollection={true}
                          selectHotel={() => handleSelectHotel(hotel)}
                        />
                      </Col>
                    ))}
                  </>
                ) : (
                  <h1 className="text-center mt-5">
                    No hay hoteles disponibles.
                  </h1>
                )}
              </>
            ) : (
              <Col className="d-flex justify-content-center mt-4">
                <Skeleton count={1} height={30} width={400} />
              </Col>
            )}
          </Row>

          {/* Botón para cargar más */}
          {visibleCards < hotelsByCAndS.length && (
            <div className="text-center mt-4">
              <Button
                className="btn-blue fw-semibold"
                style={{ width: "26%", borderRadius: "15px" }}
                onClick={handleShowMore}
              >
                Mostrar más
              </Button>
            </div>
          )}
        </Container>
      </div>

      {/**Aqui va las cards */}
      <CarouselCards
        title={"Encuentra más colecciones aquí"}
        cardsInfo={collections}
        seccion={"collections"}
      />

      <div className="py-2 py-sm-2 py-lg-5">
        <BannerDudas
          imgDudasDesk={BannerNecesitasAyuda}
          imgDudasMovil={BannerNecesitasAyudaMovil}
          bannerDudas={true}
        />
      </div>

      <div className="section-about-reservation container pb-5">
        <SectionAdvise />
      </div>
      <CheckOutCart />
    </div>
  );
};
